import styled from 'styled-components';

interface IDynamicBadgeProps {
  title: string;
  textColor?: string | null;
  backgroundColor?: string | null;
}

export const DynamicBadge = ({ title, textColor, backgroundColor }: IDynamicBadgeProps) => {
  return (
    <BadgeContainer textColor={textColor || '#FFFFFF'} backgroundColor={backgroundColor || '#FF3049'}>
      {title}
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div<{ textColor: string; backgroundColor: string }>`
  height: 28px;

  display: flex;
  align-items: center;

  padding: 8px;
  gap: 2px;

  border-radius: 4px;
  background-color: ${(props) => props.backgroundColor};

  color: ${(props) => props.textColor};
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;
